import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export const colorClasses = ['color-white', 'color-black', 'color-background', 'color-primary-text', 'color-status-success', 'color-status-warning', 'color-status-danger', 'color-secondary-sky', 'color-secondary-iris', 'color-secondary-plum', 'color-secondary-berry', 'color-secondary-coral', 'color-secondary-teal', 'color-gray-05', 'color-gray-10', 'color-gray-15', 'color-gray-20', 'color-gray-50', 'color-gray-60', 'color-gray-80', 'brand-primary', 'brand-text-link', 'brand-text-link--hover', 'brand-header-eyebrow'];
const propTypes = {
  /**
   * The svg of the icon to render
   */
  children: PropTypes.element.isRequired,
  /**
   * Set a custom class on the icon container element.
   */
  className: PropTypes.string,
  /**
   * Set a custom color for the icon. The default is 'dark-gray-80' (#1a1a1a), but this is overriddable.
   */
  strokeColor: PropTypes.string,
  /**
   * Set the stroke width for the icon. The default is 2, but this is overriddable.
   */
  strokeWidth: PropTypes.string,
  /**
   * Set a custom color for the icon. The default is 'brand-header-eyebrow', but this is overriddable.
   */
  fillAreaOne: PropTypes.oneOf(colorClasses),
  /**
   * Set a custom opacity for the fillAreaOne color. The default is 100 (fully opaque), but this can be overridden.
   */
  fillAreaOneOpacity: PropTypes.number,
  /**
   * Set a custom color for the icon. The default is 'color-white', but this is overriddable.
   */
  fillAreaTwo: PropTypes.oneOf(colorClasses),
  /**
   * Set a custom opacity for the fillAreaTwo color. The default is 50 (half transparent), but this can be overridden.
   */
  fillAreaTwoOpacity: PropTypes.number,
  /**
   * Set a custom size for the icon. Use any unit (px, em, rem, etc.)
   */
  size: PropTypes.string,
  /**
   * The ID of the icon to render.
   */
  icon: PropTypes.string,
  /**
   * Set to `true` in order to change the icon fill color to the default disabled state color (i.e. opacity 50%).
   */
  isDisabled: PropTypes.bool,
  /**
   * Alternate text for screen readers. If a label is provided, the `role` attribute will be set to `img`, otherwise it will be set to `presentation`.
   */
  label: PropTypes.string
};
function IconPlus(_ref) {
  let {
    children,
    className,
    size = '104px',
    icon,
    isDisabled,
    label,
    strokeColor = 'color-gray-80',
    strokeWidth = '2',
    fillAreaOne = 'brand-header-eyebrow',
    fillAreaOneOpacity = 100,
    fillAreaTwo = 'color-white',
    fillAreaTwoOpacity = 50
  } = _ref;
  const iconClassNames = classNames(`asc-svg-icon-plus asc-svg-icon-plus--${icon}`, className, {
    'asc-svg-icon--disabled': isDisabled
  });
  return /*#__PURE__*/React.createElement("span", {
    className: iconClassNames,
    "aria-hidden": !label,
    role: label ? 'img' : 'presentation',
    title: label || '',
    style: {
      '--icon-plus--size': `${size}`,
      '--icon-plus--stroke-color': `var(--asc-${strokeColor})`,
      '--icon-plus--stroke-width': strokeWidth,
      '--icon-plus--fill-area-one--color': `var(--asc-${fillAreaOne})`,
      '--icon-plus--fill-area-one--opacity': fillAreaOneOpacity / 100,
      '--icon-plus--fill-area-two--color': `var(--asc-${fillAreaTwo})`,
      '--icon-plus--fill-area-two--opacity': fillAreaTwoOpacity / 100
    }
  }, children);
}
IconPlus.propTypes = propTypes;
export default IconPlus;